import { Outlet, NavLink } from "react-router-dom";
import {
  FaTachometerAlt,
  FaStar,
  FaUser,
  FaCog,
  FaSignOutAlt,
  FaClipboardList,
  FaBoxes
} from "react-icons/fa";

import "../styles/dealer.css";

export default function DealerLayout() {

  const dealer =
    JSON.parse(localStorage.getItem("dealer")) || {};

  const logout = () => {
    localStorage.removeItem("dealer");
    localStorage.removeItem("dealerToken");
    window.location.href = "/dealer/login";
  };

  return (
    <div className="dealer-layout">

      {/* Sidebar */}

      <aside className="dealer-sidebar">

        <div className="dealer-brand">
          BuildNear
        </div>

        <div className="dealer-user">
          <img
            src={
              dealer.image
                ? `http://localhost:8080${dealer.image}`
                : "https://via.placeholder.com/80"
            }
            alt=""
          />

          <h5>{dealer.name}</h5>

          <span>{dealer.category}</span>
        </div>

            <nav>

              <NavLink to="/dealer/dashboard">
                <FaTachometerAlt />
                Dashboard
              </NavLink>

              <NavLink to="/dealer/inventory">
                <FaBoxes />
                Inventory
              </NavLink>

              <NavLink to="/dealer/leads">
                <FaClipboardList />
                Leads
              </NavLink>

              <NavLink to="/dealer/reviews">
                <FaStar />
                Reviews
              </NavLink>

              <NavLink to="/dealer/profile">
                <FaUser />
                Profile
              </NavLink>

            </nav>

        <button
          className="logout-btn"
          onClick={logout}
        >
          <FaSignOutAlt />
          Logout
        </button>

      </aside>

      {/* Main Area */}

      <main className="dealer-main">

        <header className="dealer-header">

          <div>
            <h3>Dealer Portal</h3>
          </div>

        </header>

        <div className="dealer-content">
          <Outlet />
        </div>

      </main>

    </div>
  );
}